module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-page"
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Element Dashboard")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "autofocus": true,
      "placeholder": "请输入用户名",
      "icon": "time"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        _vm.username = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "请输入密码",
      "type": "password",
      "icon": "time"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        _vm.password = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("记住我？")]), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    domProps: {
      "value": (_vm.rememberMe)
    },
    on: {
      "input": function($event) {
        _vm.rememberMe = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isBtnLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.login($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90a44f3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/login.vue
// module id = 562
// module chunks = 2